import { BASEURL } from "../../API/apiData";

const getAllLandingPageMesages = async () => {
  const token = localStorage.getItem("token");
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await fetch(
    `${BASEURL}landing_page_contacts`,
    requestOptions
  );
  const results = await response.json();
  return results;
};

const createNewLandingPageContact = async (data) => {
  const token = localStorage.getItem("token");
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  };
  const response = await fetch(
    `${BASEURL}landing_page_contacts`,
    requestOptions
  );
  const results = await response.json();
  return results;
};

export { createNewLandingPageContact, getAllLandingPageMesages };
